import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Plus, Trash2, Pencil, Loader2 } from "lucide-react";
import { input, btn, btnGhost } from "./adminShared";

export default function MemosTab() {
  const [memos, setMemos] = useState(null);
  const [edit, setEdit] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/memos").then(({ data }) => setMemos(data));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const blank = { title: "", category: "Vocabulaire pro", content: "", printable: true };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { title: edit.title, category: edit.category, content: edit.content, printable: true };
      if (edit.id) await api.put(`/admin/memos/${edit.id}`, payload);
      else await api.post("/admin/memos", payload);
      toast.success("Mémo enregistré ✓");
      setEdit(null);
      load();
    } catch { toast.error("Erreur"); } finally { setBusy(false); }
  };

  const remove = async (id) => { await api.delete(`/admin/memos/${id}`); toast.success("Mémo supprimé"); load(); };

  if (!memos) return <div className="flex justify-center py-20"><Loader2 className="h-7 w-7 text-orange-400 animate-spin" /></div>;

  return (
    <div>
      <div className="flex justify-end mb-5">
        <button onClick={() => setEdit({ ...blank })} className={btn} data-testid="add-memo-btn"><Plus className="h-4 w-4" /> Nouveau mémo</button>
      </div>
      <div className="space-y-3">
        {memos.map((m) => (
          <div key={m.id} className="rounded-3xl bg-white border border-slate-100 shadow-sm p-5 flex items-center gap-4">
            <div className="flex-1 min-w-0">
              <p className="text-[11px] font-extrabold uppercase text-slate-400">{m.category}</p>
              <p className="font-bold text-slate-800 truncate">{m.title}</p>
            </div>
            <button onClick={() => setEdit(m)} className={btnGhost}><Pencil className="h-4 w-4" /> Éditer</button>
            <button onClick={() => remove(m.id)} className="h-9 w-9 rounded-full bg-red-50 text-red-500 hover:bg-red-100 flex items-center justify-center"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>

      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent className="rounded-3xl max-w-lg">
          <DialogHeader><DialogTitle className="font-display text-xl">{edit?.id ? "Éditer" : "Nouveau"} mémo</DialogTitle></DialogHeader>
          {edit && (
            <form onSubmit={save} className="space-y-3 mt-2">
              <input className={input} placeholder="Titre" required value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} />
              <select className={input} value={edit.category} onChange={(e) => setEdit({ ...edit, category: e.target.value })}>
                <option>Vocabulaire pro</option><option>Règles DGCCRF</option><option>Méthode</option>
              </select>
              <textarea className={input + " min-h-[180px]"} placeholder="Contenu (markdown léger, ** pour gras)" required value={edit.content} onChange={(e) => setEdit({ ...edit, content: e.target.value })} />
              <DialogFooter><button type="submit" disabled={busy} className={btn}>{busy ? "…" : "Enregistrer"}</button></DialogFooter>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
